import * as React from 'react';
import { Alert, Button, CloseButton } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { useFetchOperation } from '../../service/Operation';
import Alerts from '../general/Alerts';
import ProgressButton from '../general/ProgressButton';
import ModeSelector from './ModeSelector';
import { UserModesSettings } from '../../types/TrainingTypes';
import ModeSettingButton from './ModeSettingButton';
import { NamedMode } from '../../types/Common';

export default function Mixed(props: {
    settings: UserModesSettings,
    setSettings: (x: UserModesSettings) => void
}) {
    const [settings, setSettings] = React.useState(props.settings.mixed);
    const dictionaries = props.settings.dictionaries;

    const [newMixed, setNewMixed] = React.useState({
        dictionaryId: dictionaries[0].id,
        dictionaryName: dictionaries[0].name,
        isDirect: true
    });

    const [showDuplicateError, setShowDuplicateError] = React.useState(false);
    const [editing, startEditing, resetEditing, setEditingError] = useFetchOperation(() => { setTimeout(resetEditing, 2000) });

    function onDictionaryChange(dictionaryId: number, dictionaryName: string) {
        resetEditing()
        setNewMixed({ ...newMixed, dictionaryId, dictionaryName });
    }

    function onIsDirectChange(isDirect: boolean) {
        resetEditing()
        setNewMixed({ ...newMixed, isDirect });
    }

    function onAddModeClick() {
        if (!settings!.find(m => m.dictionaryId === newMixed.dictionaryId
            && m.isDirect === newMixed.isDirect)) {
            setSettings([...settings!, newMixed]);
        }
        else
            setShowDuplicateError(true);
    }

    function onSettingRemove(setting: NamedMode) {
        const newSettings: NamedMode[] = [];
        settings!.forEach(x => {
            if (x.dictionaryId !== setting.dictionaryId || x.isDirect !== setting.isDirect)
                newSettings.push(x);
        })
        setSettings(newSettings);
    }

    function onSettingChanged(setting: NamedMode) {
        const newSettings: NamedMode[] = [];
        settings!.forEach(x => {
            if (x.dictionaryId !== setting.dictionaryId || x.isDirect !== setting.isDirect)
                newSettings.push(x);
            else
                newSettings.push(setting);
        })
        setSettings(newSettings);
    }

    function saveMixed() {
        if (settings!.length > 0) {
            startEditing('post', `api/study/settings/mixed`, {
                modeSettings: settings,
            });
        }
        else {
            setEditingError("No modes were added to the list");
        }
    }

    return (
        <div>
            <div>
                {!settings?.length ?
                    <p className="my-3">List of the modes in the mix is empty. Please add modes!</p>
                    :
                    <ul className="list-group mb-2">
                        {settings.map(setting =>
                            <li className="list-group-item border-0 p-0 mb-1"
                                key={setting.dictionaryId.toString() + setting.isDirect}>
                                <ModeLine setting={setting}
                                    onChange={onSettingChanged}
                                    onRemove={onSettingRemove} />
                            </li>
                        )}
                    </ul>
                }
                <div className="border border-primary rounded-3 bg-light w-auto mx-auto pt-1 pb-2 px-3 d-inline-block">

                    <ModeSelector dictionaries={dictionaries}
                        dictionaryId={newMixed.dictionaryId}
                        isDirect={newMixed.isDirect}
                        onDictionaryChange={onDictionaryChange}
                        onIsDirectChange={onIsDirectChange} />

                    <Button className="my-1"
                        variant="outline-primary"
                        onClick={onAddModeClick}
                        disabled={editing.active} >
                        Add mode to the list
                    </Button>

                    {showDuplicateError &&
                        <Alert dismissible
                            variant="danger"
                            className="my-3"
                            onClose={() => setShowDuplicateError(false)}>
                            This mode has been already added
                        </Alert>
                    }
                </div>
            </div>

            <div className="panel">
                <ProgressButton className="btn-wide panel-btn"
                    onClick={saveMixed}
                    active={editing.active}
                    success={editing.success} />
            </div>

            <Alerts
                error={editing.error}
                onClose={() => resetEditing()} />
        </div>
    )
}

function ModeLine(props: {
    setting: NamedMode,
    onChange: (x: NamedMode) => void,
    onRemove: (x: NamedMode) => void
}) {
    const mode = props.setting;
    const [modalShow, setModalShow] = React.useState(false);

    function onRemoveClick() {
        props.onRemove(props.setting);
    }

    return (
        <div>
            <Link to={`/dictionaries/${props.setting.dictionaryId}`}
                className="align-middle">{props.setting.dictionaryName}</Link>,<> </>

            <span className="align-middle me-2">
                {props.setting.isDirect ? "direct" : "inverse"}
            </span>

            <div className='d-inline-block'>
                <ModeSettingButton mode={mode} />

                <CloseButton className="align-middle"
                    onClick={onRemoveClick} />
            </div>
        </div>
    );
}
